import { ChangeDetectionStrategy, Component, Inject, OnInit, signal, WritableSignal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CardModule } from "primeng/card";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import {
  ITwoFactorRestClient,
  TwoFactorManageComponent,
  TwoFactorSetupComponent,
  twoFactorRestClientInjectionToken
} from "@zaeper/angular-2fa-lib";

@Component( {
  selector: "app-mfa-settings-page",
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    ProgressSpinnerModule,
    TwoFactorSetupComponent,
    TwoFactorManageComponent
  ],
  templateUrl: "./mfa-settings-page.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
} )
export class MfaSettingsPageComponent implements OnInit {
  public readonly loading: WritableSignal<boolean> = signal( true );
  public readonly enabled: WritableSignal<boolean> = signal( false );
  public readonly errorLoading: WritableSignal<boolean> = signal( false );

  constructor(
    @Inject( twoFactorRestClientInjectionToken ) private readonly _twoFactorRestClient: ITwoFactorRestClient
  ) {}

  public ngOnInit(): void {
    this.refreshStatus();
  }

  public refreshStatus(): void {
    this.loading.set( true );
    this.errorLoading.set( false );
    this._twoFactorRestClient.getStatus().then( ( status ) => {
      this.enabled.set( status.enabled );
      this.loading.set( false );
    } ).catch( () => {
      this.errorLoading.set( true );
      this.loading.set( false );
    } );
  }

  public onSetupComplete(): void {
    this.enabled.set( true );
  }

  public onDisabled(): void {
    this.enabled.set( false );
  }
}
